import { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes/router';
import { getOrganisationDomain, useMarfeel } from './shared';
import { store } from './store';

import 'react-loading-skeleton/dist/skeleton.css';
import 'react-toastify/dist/ReactToastify.css';

export const App: FunctionComponent = () => {
  const marfeelAccId = getOrganisationDomain() === 'ruhrnachrichten1' ? 9281 : null;

  useMarfeel(marfeelAccId);

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};
